import { pxToRem, themeGet } from '@pocketlaw/tetris';
export const TRANSITION_DURATION = 225;
export const TRANSITION_SETTINGS = `${TRANSITION_DURATION}ms ease-in-out`;
export const ICON_WIDTH = pxToRem(16);
export const ICON_CONTAINER_WIDTH = pxToRem(32);
export const LOGOTYPE_PADDING = `calc((${ICON_CONTAINER_WIDTH} - ${ICON_WIDTH}) / 2)`;
export const LIST_GAP = themeGet('spacing.sm');
export const LIST_SCROLLBAR_OFFSET = pxToRem(4);
export const SIDEBAR_PADDING = themeGet('spacing.xl');
